import * as types from '../mutation-types'
const state = {
    backups: [
]
}
const actions = {
    fetchBackups({commit}) {
        return window.axios.get('/BackUp/list').then(({data}) => {
            commit(types.STORE_BACKUPS, data)
            return data;
        })
    },
    createBackup() {
        return window.axios.post('/BackUp/create').then(response => response);
    },
    downloadBackup(_, name) {
        return window.axios.get(`backup/download/${name}`).then(({data}) => data)
    },
    cleanBackups() {
        return window.axios.post(`backup/cleanup`).then(response => response);
    }
}
const mutations = {
    [types.STORE_BACKUPS](state, backups) {
        state.backups = backups
    }
}


const getters = {

}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}